'use client';

import React from 'react';
import Link from 'next/link';

export default function SiteFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-surface-container-low/30 border-t border-outline-variant/10 py-xl">
      <div className="max-w-7xl mx-auto px-lg">
        <div className="flex flex-col md:flex-row justify-between items-start gap-xl mb-xl">
          <div className="text-left max-w-sm">
            <h2 className="text-h3 text-primary font-playfair mb-md">Eliz Ateliê</h2>
          </div>

          <div className="flex flex-wrap justify-center gap-xl">
            <div className="space-y-sm text-center md:text-left">
              <h4 className="text-label-caps text-[10px] font-black uppercase tracking-widest text-on-surface">Explorar</h4>
              <nav className="flex flex-col gap-2">
                <Link href="#inicio" className="text-sm text-secondary hover:text-primary transition-colors">Início</Link>
                <Link href="#servicos" className="text-sm text-secondary hover:text-primary transition-colors">Serviços</Link>
                <Link href="#aluguel" className="text-sm text-secondary hover:text-primary transition-colors">Aluguel</Link>
              </nav>
            </div>
            <div className="space-y-sm text-center md:text-left">
              <h4 className="text-label-caps text-[10px] font-black uppercase tracking-widest text-on-surface">Institucional</h4>
              <nav className="flex flex-col gap-2">
                <Link href="#quem-somos" className="text-sm text-secondary hover:text-primary transition-colors">Quem Somos</Link>
                <Link href="#contato" className="text-sm text-secondary hover:text-primary transition-colors">Localização</Link>
              </nav>
            </div>
          </div>
        </div>

        <div className="pt-xl border-t border-outline-variant/10 flex flex-col md:flex-row justify-between items-center gap-md">
          <div className="flex flex-col md:flex-row items-center gap-md">
            <p className="text-[10px] font-bold text-secondary/50 uppercase tracking-[0.2em]">
              © {currentYear} ELIZ ATELIÊ
            </p>
            <span className="hidden md:block w-px h-3 bg-outline-variant/30"></span>
            <a 
              href="https://jamalsoftware.com.br" 
              target="_blank" 
              className="text-[9px] font-black text-secondary/30 hover:text-primary transition-colors uppercase tracking-[0.3em]"
            >
              Desenvolvido por Jamal Software
            </a>
          </div>
          <div className="flex gap-lg">
            <Link href="#" className="text-[10px] font-bold text-secondary/50 hover:text-primary transition-colors uppercase tracking-widest">Privacidade</Link>
            <Link href="#" className="text-[10px] font-bold text-secondary/50 hover:text-primary transition-colors uppercase tracking-widest">Termos</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
